<template>
  <router-view name="cargoInsurance" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "CargoInsurance",
};
</script>
